export default {"src":"/_next/static/media/facebook.57526159.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};